import * as React from 'react';
import c from 'classnames';

import { Download, Icon } from '@uncinc/uncinc-react-kitchen-sink';
import { DownloadProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Download';

import './style.scss';

const DownloadButton: React.FC<DownloadProps> = (props) => {
  const {
    source,
    title,
    filename,
    filesize,
    mime,
    className,
  } = props;

  const classNames = c('DownloadButton', 'u-link-box', className);

  return (
    <div className={classNames}>
      <div className="DownloadButton__icon">
        <Icon name="file_download" />
      </div>

      <Download
        className="DownloadButton__link"
        source={source}
        title={title}
        filename={filename}
        filesize={filesize}
        mime={mime}
        target="_blank"
      />
    </div>
  );
};

export default DownloadButton;
